/** @forge-header
 * @id          loadingSkeletonRows
 * @role        Skeleton placeholder rows for tables during loading
 * @pattern     component
 * @tier        T3
 * @purity      none
 * @upstream    atoms/TableCells:Td
 * @downstream  ConsolidatedMoneylines
 * @exports     LoadingSkeletonRows:component | LoadingSkeletonRowsProps:interface
 * @test        untested
 */

import { Td } from '@/components/atoms/TableCells';

export interface LoadingSkeletonRowsProps {
  columns: number;
  rows?: number;
}

export function LoadingSkeletonRows({ columns, rows = 10 }: LoadingSkeletonRowsProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <tr
          key={`skeleton-${rowIdx}`}
          className="animate-pulse"
        >
          {Array.from({ length: columns }).map((_, colIdx) => (
            <Td key={`skeleton-${rowIdx}-${colIdx}`}>
              <div className="bg-muted/40 h-3 w-full rounded" />
            </Td>
          ))}
        </tr>
      ))}
    </>
  );
}
